import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  row: {
    paddingBottom: '0.5rem',
    '@media (max-width: 575px)': {
      flexFlow: 'column'
    },
    '& .adorn': {
      width: '15%',
      fontSize: theme.size.sm,

      '@media (max-width: 575px)': {
        alignSelf: 'flex-start'
      }
    }
  },

  input: {
    outline: 'none',
    border: 'none',
    width: '100%',
    resize: 'none',
    height: 'unset',
    background: 'transparent',
    fontSize: theme.size.sm
  },

  inputContainer: {
    padding: '1rem'
  },

  title: {
    marginRight: '10px',
    fontSize: theme.size.sm,
    paddingBottom: '1rem'
  }
}))

export default useStyles
